import { z } from 'zod';
import { INITIAL_DATA } from '../config';
import { constrainedStrings } from './common';
import { modelItemsSchema } from './modelItems';
import { viewsSchema } from './views';
import { validateModel } from './validation';
import { iconsSchema } from './icons';
import { colorsSchema } from './colors';

// Group instance schema for reusable group components
const groupInstanceSchema = z.object({
  id: z.string(),
  type: z.literal('GROUP_INSTANCE'),
  masterGroupId: z.string(),
  masterGroupVersion: z.number(),
  name: z.string(),
  position: z.object({ x: z.number(), y: z.number() }),
  rotation: z.number().optional(),
  scale: z.number().optional(),
  items: z.array(z.any()),
  icons: z.array(z.any()),
  colors: z.array(z.any()),
  locked: z.boolean(),
  metadata: z.object({
    createdAt: z.number(),
    lastSyncedAt: z.number(),
    isSyncEnabled: z.boolean()
  })
});

export const modelSchema = z
  .object({
    version: z.string().max(10).optional(),
    title: constrainedStrings.name,
    description: constrainedStrings.description.optional(),
    items: modelItemsSchema,
    views: viewsSchema,
    icons: iconsSchema,
    colors: colorsSchema,
    groups: z.array(z.any()).optional(), // Local groups (optional)
    groupInstances: z.array(groupInstanceSchema).optional() // Group instances (optional)
  })
  .superRefine((model, ctx) => {
    const issues = validateModel({ ...INITIAL_DATA, ...model });

    issues.forEach((issue) => {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        params: issue.params,
        message: issue.message
      });
    });
  });
